module.exports = __webpack_public_path__ + "img/extra-icon-other.fd0b3486.png";